import { ROUTES } from 'src/constants/routes.const';
import { stringifyUrl } from 'src/utils/stringifyUrl';

export type BuildingSentencesSessionUrlOptions = {
  source?: string;
  back?: string;
  pathwayNodeId?: number;
};

export const getBuildingSentencesSessionUrl = (
  languagePairId: number,
  options: BuildingSentencesSessionUrlOptions = {},
): string => {
  const params: Record<string, string | number> = { language_pair_id: languagePairId };
  if (options.source) {
    params.source = options.source;
  }
  if (options.back) {
    params.back = options.back;
  }
  if (options.pathwayNodeId !== undefined) {
    params.pathway_node_id = options.pathwayNodeId;
  }
  return stringifyUrl(ROUTES.aprender.buildingSentences, params);
};
